import React, {useEffect, useState } from "react";
import stateData from "../assets/states.json";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";

type States = {
    name: string,
    abbreviation: string,
    isEnabled: boolean
}

function StatesDropDown (props: any) {
    const { 
        className, 
        defaultValue, 
        updateSelectedState, 
        hasError, 
        helperText,
        showAllStates } = props;

    const [states, setStates] = useState<States[]>();
    
    useEffect(()=>{
        const data : States[] = stateData.states;
        setStates(data);
    }, []);

    function handleStateChange (event : any){
        updateSelectedState(event);
    };

    function renderStateOptions(){
        var menuOptions;
        if(showAllStates){
            menuOptions = states?.map((item : any) => {
                return <MenuItem key={item.abbreviation} value={item.abbreviation}>{item.name}</MenuItem>
            })
        } else {
            menuOptions = states?.filter((element)=> element.isEnabled).map((item : any) => {
                return <MenuItem key={item.abbreviation} value={item.abbreviation}>{item.name}</MenuItem>
            })
        }

        return menuOptions;
    }
    return (
        <>
            <FormControl fullWidth>
                <InputLabel id="lbl-ddlState">State</InputLabel>
                <Select
                    labelId="lbl-ddlState"
                    id="ddlState"
                    label="State"
                    defaultValue={defaultValue ?? ""}
                    value={defaultValue ?? ""}
                    onChange={handleStateChange}
                    className={className}
                    error={hasError}
                    >
                    {renderStateOptions()}
                </Select>
            </FormControl>
            
           
            {/* {selectedState && <p>Selected State: {selectedState}</p>} */}
      </>
    );
}

export default StatesDropDown;